var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({staticStyle:{"width":"160px"},attrs:{"dense":"","outlined":"","hide-details":"auto","items":_vm.socialmediaTypes,"placeholder":_vm.$t('typ'),"item-text":"text","item-value":"value"}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }